import { memo } from 'react';

import OneDriveFolderIconSVG from '@/assets/onedrive-folder-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IOneDriveFolderIcon = (props: Omit<IconProps, 'SVGComponent'>) => (
  <Icon SVGComponent={OneDriveFolderIconSVG} {...props} />
);

export const OneDriveFolderIcon = memo(IOneDriveFolderIcon) as typeof IOneDriveFolderIcon;
